<template>
  <div>
    <div align="right" style="margin: 10px">
      <Button color="primary" @click="add">新增</Button>
    </div>
    <Table :datas="categoryList" :border="true" :loading="loading">
      <TableItem title="类别名称" prop="name"></TableItem>
      <TableItem title="使用月限" prop="lifeMonths" :width="100" align="center"></TableItem>
      <TableItem title="累计折旧科目">
        <template slot-scope="{data}">
          {{ subjectName(data.depSubjectId) }}
        </template>
      </TableItem>
      <TableItem title="折旧费用科目">
        <template slot-scope="{data}">
          {{ subjectName(data.expenseSubjectId) }}
        </template>
      </TableItem>
      <TableItem title="固定资产原值科目">
        <template slot-scope="{data}">
          {{ subjectName(data.assetSubjectId) }}
        </template>
      </TableItem>
      <TableItem title="操作" width="140">
        <div class="actions" slot-scope="{data}">
          <span @click="edit(data)">编辑</span>
          <span @click="remove(data)">删除</span>
        </div>
      </TableItem>
    </Table>
    <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
      <div slot="header">固定资产类别</div>
      <Form ref="form" v-width="420" :labelWidth="130" :model="form" :rules="validationRules">
        <FormItem label="类别名称" prop="name">
          <input type="text" v-model="form.name">
        </FormItem>
        <FormItem label="使用月限" prop="lifeMonths">
          <NumberInput :min="1" v-model="form.lifeMonths"></NumberInput>
        </FormItem>
        <FormItem label="累计折旧科目" prop="depSubjectId">
          <Select v-model="form.depSubjectId" :datas="subjectList" keyName="id" titleName="name"
                  :filterable="true"></Select>
        </FormItem>
        <FormItem label="折旧费用科目" prop="expenseSubjectId">
          <Select v-model="form.expenseSubjectId" :datas="subjectList" keyName="id" titleName="name"
                  :filterable="true"></Select>
        </FormItem>
        <FormItem label="固定资产科目" prop="assetSubjectId">
          <Select v-model="form.assetSubjectId" :datas="subjectList" keyName="id" titleName="name"
                  :filterable="true"></Select>
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
        <Button @click="showForm=false" :loading="loading">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
const emptyForm = {
  name: '',
  lifeMonths: 60,
  depSubjectId: null,
  expenseSubjectId: null,
  assetSubjectId: null
};

export default {
  name: "AssetsCategory",
  data() {
    return {
      categoryList: [],
      subjectList: [],
      form: Object.assign({}, emptyForm),
      validationRules: {
        required: ['name', 'lifeMonths']
      },
      showForm: false,
      loading: false
    }
  },
  methods: {
    loadList() {
      this.loading = true;
      Promise.all([
        this.$api.assets.category.list(),
        this.$api.setting.subject.voucherSelect({})
      ]).then((results) => {
        this.categoryList = results[0].data || [];
        this.subjectList = results[1].data || [];
      }).finally(() => this.loading = false);
    },
    subjectName(subjectId) {
      if (!subjectId) {
        return '-';
      }
      let subject = this.subjectList.find(val => val.id === subjectId);
      return subject ? `${subject.code}-${subject.name}` : '-';
    },
    add() {
      this.form = Object.assign({}, emptyForm);
      this.showForm = true;
    },
    edit(data) {
      this.form = Object.assign({}, data);
      this.showForm = true;
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (validResult.result) {
        this.loading = true;
        this.$api.assets.category[this.form.id ? 'update' : 'save'](this.form).then(() => {
          this.$Message('保存成功~');
          this.showForm = false;
          this.loadList();
        }).catch(() => {
        }).finally(() => this.loading = false);
      }
    },
    remove(data) {
      this.$Confirm("确认删除?").then(() => {
        this.$api.assets.category.delete(data.id).then(() => {
          this.loadList();
        })
      })
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>
